(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hi-lab-age-gate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hi-lab-age-gate')) {
    customElements.define('hi-lab-age-gate', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.abort || !this.isConnected) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.abort = new AbortController();
        this.options = { signal: this.abort.signal };
        this.editor = this.dataset.editor === 'true';
        this.key = 'hi_lab_age_verified_v1_' + this.dataset.theme;
        this.hours = Math.min(8760, Math.max(1, Number(this.dataset.hours) || 880));
        this.accept = this.querySelector('[data-age-accept]');
        this.exit = this.querySelector('[data-age-exit]');
        this.status = this.querySelector('[data-age-status]');
        this.accept.disabled = false;
        this.accept.addEventListener('click', () => this.confirm(), this.options);
        this.exit.addEventListener('click', event => this.refuse(event), this.options);
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          if (this.editor) this.close();
        }, this.options);
        this.dialog.addEventListener('keydown', event => this.trapFocus(event), this.options);
        this.querySelector('[data-age-preview]')?.addEventListener('click', () => this.open(), this.options);
        this.querySelector('[data-age-close]')?.addEventListener('click', () => this.close(), this.options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && event.detail.sectionId === this.dataset.sectionId) this.open();
        }, this.options);
        document.addEventListener('shopify:section:deselect', event => {
          if (this.editor && event.detail.sectionId === this.dataset.sectionId) this.close();
        }, this.options);
        window.addEventListener('pageshow', () => {
          if (!this.editor && !this.isVerified() && !this.dialog.open) this.open();
        }, this.options);
        document.addEventListener('visibilitychange', () => {
          if (!this.editor && document.visibilityState === 'visible' && !this.isVerified() && !this.dialog.open) this.open();
        }, this.options);
        if (this.editor || this.isVerified()) this.dialog.removeAttribute('open');
        else this.open();
      }

      isVerified() {
        return ['localStorage', 'sessionStorage'].some(kind => {
          try {
            const expires = Number(window[kind].getItem(this.key));
            return Number.isFinite(expires) && expires > Date.now() && expires <= Date.now() + this.hours * 3600000 + 60000;
          } catch { return false; }
        });
      }

      open() {
        if (this.modalActive) return;
        this.previousFocus = document.activeElement;
        this.querySelector('[data-age-refused]').hidden = true;
        this.dialog.removeAttribute('open');
        document.documentElement.classList.add('hi-age-locked');
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        this.modalActive = true;
        this.exit.focus({ preventScroll: true });
      }

      close() {
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
        this.modalActive = false;
        document.documentElement.classList.remove('hi-age-locked');
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }

      confirm() {
        if (this.editor) this.status.textContent = this.status.dataset.accepted;
        else {
          const expires = String(Date.now() + this.hours * 3600000);
          for (const kind of ['localStorage', 'sessionStorage']) {
            try { window[kind].setItem(this.key, expires); } catch {}
          }
        }
        this.close();
      }

      refuse(event) {
        if (this.editor) {
          event.preventDefault();
          this.querySelector('[data-age-refused]').hidden = false;
          this.status.textContent = this.status.dataset.refused;
        } else {
          for (const kind of ['localStorage', 'sessionStorage']) {
            try { window[kind].removeItem(this.key); } catch {}
          }
        }
      }

      trapFocus(event) {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]), a[href]')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        if (this.dialog?.open) this.close();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
